export const INTERCOM_SESSION_CHANGED_EVENT = "tlmc:intercom-session-changed"

export function notifyIntercomSessionChanged() {
  if (typeof window === "undefined") {
    return
  }

  window.dispatchEvent(new Event(INTERCOM_SESSION_CHANGED_EVENT))
}
